import { render, staticRenderFns } from "./ContractDetailsFiles.vue?vue&type=template&id=80bf7434&scoped=true"
import script from "./ContractDetailsFiles.vue?vue&type=script&lang=js"
export * from "./ContractDetailsFiles.vue?vue&type=script&lang=js"
import style0 from "./ContractDetailsFiles.vue?vue&type=style&index=0&id=80bf7434&prod&lang=scss&scoped=true"
import style1 from "./ContractDetailsFiles.vue?vue&type=style&index=1&id=80bf7434&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bf7434",
  null
  
)

export default component.exports